import React from 'react'
import { textStyles } from '@marketing-sites/ui'
import type { ComposeComponentLinkFragment } from '../../../.graphql/generated-types'
import { LinkToArticlePage } from '../LinkToArticlePage'

export interface ComposeComponentLinkProps {
  data: ComposeComponentLinkFragment
}

export function ComposeComponentLink({ data }: ComposeComponentLinkProps) {
  const opensInANewTab = data.opensInANewTab ?? false
  const text = data.text ?? ''
  const target = opensInANewTab ? '_blank' : '_self'
  const rel = opensInANewTab ? 'noreferrer' : ''
  const style = textStyles.a
  switch (data.link?.__typename) {
    case 'ComposeComponentUrl':
      return (
        <a
          href={data.link.url ?? ''}
          target={target}
          rel={rel}
          className={style}
        >
          {text}
        </a>
      )
    case 'ComposePageArticle':
      return (
        <LinkToArticlePage article={data.link} className={style}>
          {text}
        </LinkToArticlePage>
      )
    default:
      return null
  }
}
